import { Controller } from "@hotwired/stimulus"

// Remembers which Bootstrap collapses inside this element are open, so they
// stay open when the page is refreshed (e.g. after a drag-and-drop reorder).
export default class extends Controller {
  static values = { key: String }

  connect() {
    this.open = new Set(this.read())
    this.element.querySelectorAll(".collapse").forEach((panel) => {
      if (!this.open.has(panel.id)) return
      panel.classList.add("show")
      this.element.querySelector(`[data-bs-target="#${panel.id}"]`)?.classList.remove("collapsed")
    })
  }

  toggled(event) {
    this.open[event.type === "shown" ? "add" : "delete"](event.target.id)
    try { sessionStorage.setItem(this.keyValue, JSON.stringify([...this.open])) } catch (_) {}
  }

  read() {
    try { return JSON.parse(sessionStorage.getItem(this.keyValue)) || [] } catch (_) { return [] }
  }
}
